import React, {useState, useEffect} from "react";
import {API} from './api-service';
import {useCookies} from 'react-cookie';
import { Form, Button, Col, Row, Alert } from "react-bootstrap";

function Register() {

    const [token,setToken] = useCookies(['pn-token'])

    useEffect( () => {
        if (token['pn-token']) window.location.href = '/cases'
    },[token])

  const [formData, setFormData] = useState({
    username: "",
    password: "",
    confirmPassword: "",
    idNumber: "",
    name: "",
    registrationNumber: "",
    addressLine1: "",
    addressLine2: "",
    town: "",
    province: "",
    email: "",
  });

  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Validate the form data
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    if (!formData.email.includes("@")) {
      setError("Invalid email address");
      return;
    }
    // Submit the form data
    API.registerNurse(formData);
    // console.log(formData)
    setError("");
  };

  return (
    <Form className="Register-Form" onSubmit={handleSubmit}>
      <h1 style={{textAlign: 'center', marginTop: '50px', marginBottom: '50px'}}>Register</h1>
      {error && <Alert variant="danger">{error}</Alert>}
      <Form.Group as={Row} className="mb-3" controlId="username">
        <Form.Label column sm="2">
          Username:
        </Form.Label>
        <Col sm="10">
          <Form.Control
            type="text"
            name="username"
            value={formData.username}
            onChange={handleChange}
            required
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="mb-3" controlId="password">
        <Form.Label column sm="2">
          Password:
        </Form.Label>
        <Col sm="10">
          <Form.Control
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="mb-3" controlId="confirmPassword">
        <Form.Label column sm="2">
          Confirm Password:
        </Form.Label>
        <Col sm="10">
          <Form.Control
            type="password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="mb-3" controlId="idNumber">
        <Form.Label column sm="2">
          ID Number:
        </Form.Label>
        <Col sm="10">
          <Form.Control
            type="text"
            name="idNumber"
            value={formData.idNumber}
            onChange={handleChange}
            required
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="mb-3" controlId="name">
        <Form.Label column sm="2">
          Name:
        </Form.Label>
        <Col sm="10">
          <Form.Control
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="mb-3" controlId="registrationNumber">
        <Form.Label column sm="2">
          Registration Number:
        </Form.Label>
        <Col sm="10">
          <Form.Control
            type="text"
            name="registrationNumber"
            value={formData.registrationNumber}
            onChange={handleChange}
            required
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="mb-3" controlId="addressLine1">
        <Form.Label column sm="2">
          Address Line 1:
        </Form.Label>
        <Col sm="10">
          <Form.Control
            type="text"
            name="addressLine1"
            value={formData.addressLine1}
            onChange={handleChange}
            required
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="mb-3" controlId="addressLine2">
        <Form.Label column sm="2">
          Address Line 2:
        </Form.Label>
        <Col sm="10">
          <Form.Control
            type="text"
            name="addressLine2"
            value={formData.addressLine2}
            onChange={handleChange}
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="mb-3" controlId="town">
        <Form.Label column sm="2">
          Town:
        </Form.Label>
        <Col sm="10">
          <Form.Control
            type="text"
            name="town"
            value={formData.town}
            onChange={handleChange}
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="mb-3" controlId="province">
        <Form.Label column sm="2">
          Province:
        </Form.Label>
        <Col sm="10">
          <Form.Control
            type="text"
            name="province"
            value={formData.province}
            onChange={handleChange}
            required
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="mb-3" controlId="email">
        <Form.Label column sm="2">
          Email:
        </Form.Label>
        <Col sm="10">
          <Form.Control
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </Col>
      </Form.Group>
      <Button variant="primary" type="submit">
        Submit
      </Button>
      <p style={{margin: 'auto'}}>Already Registered? <a href="/">Login</a> instead.</p>
    </Form>
  );
}

export default Register;